<div class="header_hero-bg"></div>

<div class="mega-trade-container container-fluid">
  <div class="mega_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header">Committed Pools</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-7 col-lg-7 committed-mega-text">
          <p>
            Below is a list of your committed pools. If you notice any issues or would like to make
            changes to any of your pools, please contact Fannie Mae Structured Transactions.
          </p>
        </div>
        <div class="col-12 col-sm-12 col-md-5 col-lg-5 committed-mega-text d-flex flex-column">
          <p class="upload-text">Ready to upload your pool information?</p>
          <br />
          <span class="ms-auto">
            <i
              class="fa fa-download download-template-icon"
              (click)="downloadPoolInfoTemplate()"
            ></i>
            <a class="download-pool-info-template" (click)="downloadPoolInfoTemplate()"
              >Download Pool Information Template (.xlsx)</a
            >
          </span>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break__padding">
          <div class="line-break"></div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information-committed">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 committed-mega-tab">
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-3"
            (click)="showMegaType('SFFIXMEGA')"
            [ngClass]="{ 'selected-mega-type-text': showSFFixedMega }"
          >
            Single Family Fixed Rate <span class="badge badge-warning">{{ totalSFFixedMega }}</span>
            <div
              class="line-break-tab"
              [ngClass]="{ 'selected-mega-type-border': showSFFixedMega }"
            ></div>
          </div>
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-3"
            (click)="showMegaType('SFARMMEGA')"
            [ngClass]="{ 'selected-mega-type-text': showSFARMMega }"
          >
            Single Family ARM <span class="badge badge-warning">{{ totalSFARMMega }}</span>
            <div
              class="line-break-tab"
              [ngClass]="{ 'selected-mega-type-border': showSFARMMega }"
            ></div>
          </div>
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-3"
            (click)="showMegaType('MFFIXMEGA')"
            [ngClass]="{ 'selected-mega-type-text': showMFFixedMega }"
          >
            Multi Family Fixed Rate <span class="badge badge-warning">{{ totalMFFixedMega }}</span>
            <div
              class="line-break-tab"
              [ngClass]="{ 'selected-mega-type-border': showMFFixedMega }"
            ></div>
          </div>
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-3"
            (click)="showMegaType('MFARMMEGA')"
            [ngClass]="{ 'selected-mega-type-text': showMFARMMega }"
          >
            Multi Family ARM <span class="badge badge-warning">{{ totalMFARMMega }}</span>
            <div
              class="line-break-tab"
              [ngClass]="{ 'selected-mega-type-border': showMFARMMega }"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information-committed">
      <div class="row committed-mega-table" *ngIf="showMessage">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
          <p>{{ errorMessage }}</p>
          <p>Would you like to create a new pool now?</p>
          <div class="create-mega-buttons-row">
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 create-mega-button">
              <button
                class="button fm-primary-button col-12 bulk-mega-button single-mega-button-width"
                [disabled]="!hasCreateOrEditMegaAccessFlag"
                (click)="navigatePageTo('/mega-trade/enter-details')"
              >
                CREATE SINGLE POOL
              </button>
            </div>
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 create-mega-button">
              <button
                class="button fm-primary-button col-12 bulk-mega-button bulk-mega-button-width"
                [disabled]="!hasCreateOrEditMegaAccessFlag"
                (click)="navigatePageTo('bulk-upload/enter-mega-details')"
              >
                CREATE MULTIPLE POOLS
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row committed-mega-table" *ngIf="!showMessage">
        <invd-committed-mega-table
          [SFFixedMegaList]="SFFixedMegaList"
          [SFARMMegaList]="SFARMMegaList"
          [MFFixedMegaList]="MFFixedMegaList"
          [MFARMMegaList]="MFARMMegaList"
          [showMFFixedMega]="showMFFixedMega"
          [showSFFixedMega]="showSFFixedMega"
          [showSFARMMega]="showSFARMMega"
          [showMFARMMega]="showMFARMMega"
          [singleFamilyARMMega]="singleFamilyARMMega"
          [multiFamilyFixedMega]="multiFamilyFixedMega"
          [multiFamilyARMMega]="multiFamilyARMMega"
          [showMessage]="showMessage"
          [singleFamilyFixedMega]="singleFamilyFixedMega"
          [displayPagi]="displayPagination"
          (editMegaClick)="editMegaClick($event)"
          (downloadCollateralClicked)="downloadCollateralPoolFromParent($event)"
          [totalCommittedCurrentMonthSFFIXMEGA]="totalCommittedCurrentMonthSFFIXMEGA"
          [totalCommittedCurrentMonthSFARMMEGA]="totalCommittedCurrentMonthSFARMMEGA"
          [totalCommittedCurrentMonthMFFIXMEGA]="totalCommittedCurrentMonthMFFIXMEGA"
          [totalCommittedCurrentMonthMFARMMEGA]="totalCommittedCurrentMonthMFARMMEGA"
          [totalCommittedVolumeSFFIXMEGA]="totalCommittedVolumeSFFIXMEGA"
          [totalCommittedVolumeSFARMMEGA]="totalCommittedVolumeSFARMMEGA"
          [totalCommittedVolumeMFFIXMEGA]="totalCommittedVolumeMFFIXMEGA"
          [totalCommittedVolumeMFARMMEGA]="totalCommittedVolumeMFARMMEGA"
          [hasCreateOrEditMegaAccessFlag]="hasCreateOrEditMegaAccessFlag"
          [hasCollateralUploadAccessFlag]="hasCollateralUploadAccessFlag"
          [hasListSettledAndCommittedAccessFlag]="hasListSettledAndCommittedAccessFlag"
          (fileUploaded)="onFileUpload($event)"
          [featuretoggle]="featuretoggle"
          [isInternalUser]="isInternalUser"
          (deallocation)="refreshList()"
        >
        </invd-committed-mega-table>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="displayInValidFilePopup">
  <div class="upload-model-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="panel-body mega-cancel-confirmation-model">
        <span><p class="faban"></p></span>
        <ng-container *ngIf="!displayInValidResponseFilePopup">
          <h4>There was an issue with your file.</h4>
          <br />
          <p>
            The file you uploaded is not in an acceptable format. Please make sure your file format
            is .csv, .xls or .xslx.
          </p>
          <br />
        </ng-container>
        <ng-container *ngIf="displayInValidResponseFilePopup">
          <h4>An unexpected error occured.</h4>
          <br />
          <p>Please try your upload again.</p>
          <br />
        </ng-container>

        <button class="button fm-primary-button" (click)="displayInValidFileStatusPopup()">
          CLOSE
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="displayValidFilePopup">
  <div class="upload-model-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="panel-body mega-cancel-confirmation-model">
        <h4>Your file has been recieved</h4>
        <br />
        <p>Please refresh the page to view the status of your collateral.</p>
        <br /><br />
        <button class="button fm-primary-button" (click)="displayValidFileStatusPopup()">OK</button>
      </div>
    </div>
  </div>
</ng-container>
